import { render, staticRenderFns } from "./TransferRequestDetailsView.vue?vue&type=template&id=e1b29234"
import script from "./TransferRequestDetailsView.vue?vue&type=script&lang=js"
export * from "./TransferRequestDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports